import React, { useCallback, useEffect, useState } from 'react';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { useUpdateLectureContentMutation } from '@classCreation/services/lectureContentService';
import FieldErrors from 'components/FieldErrors';
import Form from 'components/Form';
import LectureContentInput from '../LectureContentInput';

export default function EditLectureContentForm({
  isEditing,
  setIsEditing,
  lectureContent,
  academyTopicId,
  label,
}) {
  const [content, setContent] = useState(lectureContent);
  const [
    updateLectureContent,
    { isSuccess, isLoading: isUpdating, error, reset },
  ] = useUpdateLectureContentMutation();

  useEffect(() => {
    if (!isEditing) {
      setContent(lectureContent);
      if (error) {
        reset();
      }
    }
  }, [error, isEditing, lectureContent, reset]);

  const handleOnChange = useCallback((newContent) => {
    setContent(newContent);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lecture content is successfully updated!');
      setIsEditing(false);
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in updating the lecture content. Please try again later!'
      );
    }
  }, [error, isSuccess, setIsEditing]);

  const handleEditContent = useCallback(
    (event) => {
      event.preventDefault();
      updateLectureContent({ academyTopicId, content });
    },
    [academyTopicId, content, updateLectureContent]
  );

  return (
    <Form onSubmit={handleEditContent}>
      <LectureContentInput
        contentType={lectureContent.content_type}
        value={content}
        onChange={handleOnChange}
        containerClassName="m-b-xs"
        placeholder={`Enter ${label}`}
        disabled={!isEditing}
      />
      <FieldErrors
        name="content"
        errors={error?.data?.errors}
      />
      {isEditing && (
        <Tappable
          className="btn btn-primary"
          component="button"
          disabled={isUpdating}
          type="submit"
        >
          Update {label}
        </Tappable>
      )}
    </Form>
  );
}
